import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth_not_requeired/logout")({
  component: () => <div>Hello /logout!</div>,
});
